import React from "react";

const SimpleLayout = ({ children }) => {
  return <div className="simple-layout-container">{children}</div>;
};

export default SimpleLayout;
